/*
    Here the function name is the same from actions.
    Simple for referring
*/

import {
  GOOGLE_AUTH,
  GOOGLE_AUTH_ERROR,
  AUTHENTICATION_FALSE,
  AUTHENTICATION_TRUE,
  CREATE_POST_SUCCESS,
  CREATE_POST_ERROR,
  GET_POST_SUCCESS,
  GET_POST_ERROR,
  GET_TAGS_SUCCESS,
  GET_TAGS_ERROR,
  CLEAR_POST_SUCCESS_ERROR,
  SINGLE_ARTICLE_SUCCESS,
  SINGLE_ARTICLE_ERROR,
  SINGLE_ARTICLE_COMMENTS_SUCCESS,
  SINGLE_ARTICLE_COMMENTS_ERROR,
  SUBMIT_COMMENT_SUCCESS,
  SUBMIT_COMMENT_ERROR,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_ERROR,
  LIKE_ARTICLE_SUCCESS,
  LIKE_ARTICLE_ERROR,
  DISLIKE_ARTICLE_SUCCESS,
  DISLIKE_ARTICLE_ERROR,
  UNFOLLOW_USER_ERROR,
  UNFOLLOW_USER_SUCCESS,
  FOLLOW_USER_ERROR,
  FOLLOW_USER_SUCCESS,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_ERROR,
  DELETE_COMMENT_RESET,
  USER_FEED_SUCCESS,
  USER_FEED_ERROR,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_ERROR,
  USER_LOGOUT,
  GET_POST_AUTHOR_SUCCESS,
  GET_POST_AUTHOR_ERROR,
  USER_POST_SUCCESS,
  USER_POST_ERROR,
  TAG_POST_SUCCESS,
  TAG_POST_ERROR
} from "./actionTypes";

export function googleAuth(res) {
  return {
    type: GOOGLE_AUTH,
    payload: res,
  };
}

export function userLogout() {
  return {
    type: USER_LOGOUT
  }
}

export function googleAuthError(res) {
  return {
    type: GOOGLE_AUTH_ERROR,
    payload: res,
  };
}

export function getTagsSuccess(res) {
  return {
    type: GET_TAGS_SUCCESS,
    payload: res,
  };
}

export function getTagsError(res) {
  return {
    type: GET_TAGS_ERROR,
    payload: res,
  };
}

export function getPostSuccess(res) {
  return {
    type: GET_POST_SUCCESS,
    payload: res,
  };
}

export function getPostError(res) {
  return {
    type: GET_POST_ERROR,
    payload: res,
  };
}

export function getPostAuthorSuccess(res) {
  return {
    type: GET_POST_AUTHOR_SUCCESS,
    payload: res
  }
}

export function getPostAuthorError(res) {
  return {
    type: GET_POST_AUTHOR_ERROR,
    payload: res
  }
}

export function userPostsSuccess(res) {
  return {
    type: USER_POST_SUCCESS,
    payload: res
  }
}

export function userPostsError(res) {
  return {
    type: USER_POST_ERROR,
    payload: res
  }
}

export function tagPostsSuccess(res) {
  return {
    type: TAG_POST_SUCCESS,
    payload: res
  }
}

export function tagPostsError(res) {
  return {
    type: TAG_POST_ERROR,
    payload: res
  }
}

export function createPostSuccess(res) {
  return {
    type: CREATE_POST_SUCCESS,
    payload: res,
  };
}

export function createPostError(res) {
  return {
    type: CREATE_POST_ERROR,
    payload: res,
  };
}

export function clearPostSuccessError() {
  return {
    type: CLEAR_POST_SUCCESS_ERROR,
  };
}

export function singleArticleSuccess(res) {
  return {
    type: SINGLE_ARTICLE_SUCCESS,
    payload: res,
  };
}

export function singleArticleError(res) {
  return {
    type: SINGLE_ARTICLE_ERROR,
    payload: res,
  };
}

export function singleArticleCommentsSuccess(res) {
  return {
    type: SINGLE_ARTICLE_COMMENTS_SUCCESS,
    payload: res,
  };
}

export function singleArticleCommentsError(res) {
  return {
    type: SINGLE_ARTICLE_COMMENTS_ERROR,
    payload: res,
  };
}

export function userUpdateSuccess(res) {
  return {
    type: USER_UPDATE_SUCCESS,
    payload: res,
  };
}

export function userUpdateError(res) {
  return {
    type: USER_UPDATE_ERROR,
    payload: res,
  };
}

export function userUpdateReset(res) {
  return {
    type: USER_UPDATE_ERROR,
    payload: res,
  };
}

export function submitCommentSuccess(res) {
  return {
    type: SUBMIT_COMMENT_SUCCESS,
    payload: res,
  };
}

export function deleteCommentReset() {
  return {
    type: DELETE_COMMENT_RESET,
  };
}

export function submitCommentError(res) {
  return {
    type: SUBMIT_COMMENT_ERROR,
    payload: res,
  };
}

export function userFeedSuccess(res) {
  return {
    type: USER_FEED_SUCCESS,
    payload: res,
  };
}

export function userFeedError(res) {
  return {
    type: USER_FEED_ERROR,
    payload: res,
  };
}

export function getCurrentUserSuccess(res) {
  return {
    type: GET_CURRENT_USER_SUCCESS,
    payload: res,
  };
}

export function getCurrentUserError(res) {
  return {
    type: GET_CURRENT_USER_ERROR,
    payload: res,
  };
}

export function likeArticleSuccess(res) {
  return {
    type: LIKE_ARTICLE_SUCCESS,
    payload: res,
  };
}

export function likeArticleError(res) {
  return {
    type: LIKE_ARTICLE_ERROR,
    payload: res,
  };
}

export function dislikeArticleSuccess(res) {
  return {
    type: DISLIKE_ARTICLE_SUCCESS,
    payload: res,
  };
}

export function dislikeArticleError(res) {
  return {
    type: DISLIKE_ARTICLE_ERROR,
    payload: res,
  };
}

export function followUserSuccess(res) {
  return {
    type: FOLLOW_USER_SUCCESS,
    payload: res,
  };
}

export function followUserError(res) {
  return {
    type: FOLLOW_USER_ERROR,
    payload: res,
  };
}

export function unfollowUserSuccess(res) {
  return {
    type: UNFOLLOW_USER_SUCCESS,
    payload: res,
  };
}

export function unfollowUserError(res) {
  return {
    type: UNFOLLOW_USER_ERROR,
    payload: res,
  };
}

export function deleteCommentSuccess(res) {
  return {
    type: DELETE_COMMENT_SUCCESS,
    payload: res,
  };
}

export function deleteCommentError(res) {
  return {
    type: DELETE_COMMENT_ERROR,
    payload: res,
  };
}

export function googleAuthTrue() {
  return {
    type: AUTHENTICATION_TRUE,
  };
}

export function googleAuthFalse() {
  return {
    type: AUTHENTICATION_FALSE,
  };
}
